export const TYPES = {
  SET_NOTIFICATION: "notification/SET_NOTIFICATION",
};
